import queen from "./queen.png";
import ant from "./ant.png";
import beetle from "./beetle.png";
import grasshopper from "./grasshopper.png";
import spider from "./spider.png";

export const classic = {
  queen,
  ant,
  beetle,
  grasshopper,
  spider,
};
